// A readable message from a failed API call.
//
// FastAPI sends `detail` as a string for errors the app raises, but as a LIST
// of objects ({loc, msg, type}) for request-validation errors (422). Storing
// that list as an error message and rendering it crashes React, and with no
// error boundary the whole page goes blank - so always go through this.
export function formatApiError(error, fallback = 'Something went wrong') {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => (item && typeof item.msg === 'string' ? item.msg.replace(/^Value error, /, '') : null))
      .filter(Boolean);
    if (messages.length) return messages.join('; ');
  }
  if (detail && typeof detail === 'object' && typeof detail.message === 'string') return detail.message;
  return fallback;
}

export default formatApiError;
